/**
 * @module cercaliagl/view/VWidgetSearch
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import $ from 'jquery';
import { MDCSelect } from '@material/select';
import { MDCTextField } from '@material/textfield';
import { MDCTabBar } from '@material/tab-bar';
import { MDCCheckbox } from '@material/checkbox';
import BaseView, { EventType as BaseViewEventType } from './BaseView';
import { i18n } from '../dictionary';
import { createUid, isMobile } from '../util';
import { createCheckbox, createSelect, createTabBar, createSelectOptionItem, createFilledTextField, createTextButton, } from './VUtils';
/**
 * @typedef {Object} AddressSearchOption
 * @property {Array.<string>} getype
 * @property {string} text
 * @property {string|undefined} ctryc
 */
/**
 * @typedef {Object} CoordinateSearchOption
 * @property {string} x
 * @property {string} y
 * @property {string} srs
 * @property {boolean} nearest
 */
/**
 * @enum {number}
 */
var Tabs = {
    ADDRESS: 0,
    COORDINATES: 1,
};
/**
 * @enum {string}
 */
var Proj = {
    EPSG4326: 'EPSG:4326',
    EPSG3857: 'EPSG:3857',
};
/**
 * @enum {string}
 */
export var EventType = {
    CLOSE_MENU: 'close_menu',
    MINIMIZE: 'minimize',
    OPTIONS_CHANGED: 'options_changed',
    PCODE_SUBMIT: 'pcode_submit',
    PCODE_SELECT_CANDIDATE: 'pcode_select_candidate',
    COORD_SUBMIT: 'coord_submit',
    SELECT_CAND: 'select_cand',
};
/**
 * @classdesc
 */
var VWidgetSearch = /** @class */ (function (_super) {
    __extends(VWidgetSearch, _super);
    /**
     * @constructor
     */
    function VWidgetSearch() {
        var _this = this;
        var uid = createUid();
        var autocompleteId = "addressTabAutocomplete".concat(uid);
        var jqElement = $("\n      <div class=\"v-widgetsearch mdc-elevation--z4\">\n        <div class=\"header\">\n          ".concat(createTabBar([i18n('Address'), i18n('searchCoordinates')]), "\n          <div class=\"btn-close\">\n            <button type=\"button\" class=\"mdc-icon-button close\">\n              <span class=\"mdc-icon-button__icon icon-close\"></span>\n            </button>\n          </div>\n        </div>\n        <div class=\"container\">\n          <div class=\"addressTab\">\n            <div id=\"").concat(autocompleteId, "\"></div>\n            ").concat(createSelect('select-country', [], null, i18n('searchSelectCountry')), "\n            <div class=\"getype\"> \n              ").concat(createCheckbox('locality', 'ct', i18n('searchLocality'), true), "\n              ").concat(createCheckbox('address', 'st', i18n('searchAddress'), true), "\n              ").concat(createCheckbox('pois', 'p', i18n('searchPOIs'), true), "\n            </div>\n          </div>\n\n          <div class=\"coordinatesTab\">\n            <div class=\"coords-inputs\">\n              ").concat(createFilledTextField('coordx', i18n('searchXCoordinate')), "\n              ").concat(createFilledTextField('coordy', i18n('searchYCoordinate')), "\n            </div>\n            <div class=\"select-proj\">\n              ").concat(createSelect('proj', [{ label: Proj.EPSG4326, value: Proj.EPSG4326 }, { label: Proj.EPSG3857, value: Proj.EPSG3857 }], Proj.EPSG4326, i18n('searchProjection')), "\n            </div>\n            <div class=\"coords-actions\">\n              ").concat(createCheckbox('nearest', 'nearest', i18n('searchNearestAddress'), true), "\n              ").concat(createTextButton('searchPcodeBtn', i18n('searchSearchBtn')), "\n            </div>\n          </div>\n        </div>\n      </div>"));
        _this = _super.call(this, jqElement) || this;
        /**
         * @private
         * @type {string}
         */
        _this.autocompleteId_ = autocompleteId;
        /**
         * @private
         * @type {number}
         */
        _this.currentTab_ = Tabs.ADDRESS;
        /**
         * @private
         * @type {JQuery}
         */
        _this.jqAddressTab_ = _this.jqElement_.find('.addressTab');
        /**
         * @private
         * @type {JQuery}
         */
        _this.jqCoordinatesTab_ = _this.jqElement_.find('.coordinatesTab');
        /**
         * @private
         * @type {AddressSearchOption}
         */
        _this.addressSearchOption_ = {
            getype: ['st', 'ct', 'p'],
            text: null,
            ctryc: null,
        };
        /**
         * @private
         * @type {CoordinateSearchOption}
         */
        _this.coordinateSearchOption_ = {
            x: null,
            y: null,
            srs: 'EPSG:4326',
            nearest: true,
        };
        /**
         * @private
         * @type {MDCSelect}
         */
        _this.selectAddressCountry_ = null;
        _this.initializeElements_();
        return _this;
    }
    /**
     * @private
     */
    VWidgetSearch.prototype.initializeElements_ = function () {
        var _this = this;
        this.on(BaseViewEventType.ATTACHED, function () { return _this.handleAttached_(); });
        this.render_();
    };
    /**
     * @private
     */
    VWidgetSearch.prototype.handleAttached_ = function () {
        var _this = this;
        if (!this.jqElement_) {
            return;
        }
        this.adjustByDevice();
        // Button close
        var jqButtonClose = this.jqElement_.find('button.close');
        if (!jqButtonClose) {
            return;
        }
        jqButtonClose.click(function () { return _this.emit(EventType.CLOSE_MENU); });
        // Buttons (change tab)
        var tabBar = new MDCTabBar(this.jqElement_.find('.mdc-tab-bar').get(0));
        tabBar.listen('MDCTabBar:activated', function (e) {
            _this.currentTab_ = e.detail.index;
            _this.render_();
        });
        /// //////////////////////
        // Tab Address
        /// //////////////////////
        this.selectAddressCountry_ = new MDCSelect(this.jqAddressTab_.find('.mdc-select.select-country').get(0)); // Select country
        this.selectAddressCountry_.listen('MDCSelect:change', function () {
            _this.addressSearchOption_.ctryc = _this.selectAddressCountry_.value !== 'all' ? _this.selectAddressCountry_.value : undefined;
            _this.emit(EventType.OPTIONS_CHANGED, _this.addressSearchOption_);
        });
        // Checkbox events
        this.jqElement_.find('.getype input[type=checkbox]').change(function (e) {
            var checkbox = e.currentTarget;
            var currentValue = checkbox.value;
            if (checkbox.checked) {
                _this.addressSearchOption_.getype.push(currentValue);
            }
            else {
                var index = _this.addressSearchOption_.getype.indexOf(currentValue);
                if (index !== -1) {
                    _this.addressSearchOption_.getype.splice(index, 1);
                }
            }
            _this.emit(EventType.OPTIONS_CHANGED, _this.addressSearchOption_);
        });
        /// //////////////////////
        // Tab coordinates
        /// //////////////////////
        var inputCoordX = new MDCTextField(this.jqCoordinatesTab_.find('.mdc-text-field.coordx').get(0));
        var inputCoordY = new MDCTextField(this.jqCoordinatesTab_.find('.mdc-text-field.coordy').get(0));
        var selectCoordinateProj = new MDCSelect(this.jqCoordinatesTab_.find('.mdc-select.proj').get(0));
        var checkbox = new MDCCheckbox(this.jqCoordinatesTab_.find('.nearest').get(0));
        inputCoordX.listen('input', function () {
            _this.coordinateSearchOption_.x = inputCoordX.value;
        });
        inputCoordY.listen('input', function () {
            _this.coordinateSearchOption_.y = inputCoordY.value;
        });
        selectCoordinateProj.listen('MDCSelect:change', function () {
            _this.coordinateSearchOption_.srs = selectCoordinateProj.value;
        });
        checkbox.listen('change', function () {
            _this.coordinateSearchOption_.nearest = checkbox.checked;
        });
        this.jqCoordinatesTab_.find('button.searchPcodeBtn').click(function () {
            _this.emit(EventType.COORD_SUBMIT, _this.coordinateSearchOption_);
        });
    };
    /**
     * Adjust size by device
     */
    VWidgetSearch.prototype.adjustByDevice = function () {
        this.jqElement_.css('width', !isMobile() ? 'auto' : this.getMapViewport().offsetWidth - 10);
    };
    /**
     * @param {Array.<Object>} countries Countries
     */
    VWidgetSearch.prototype.setCountries = function (countries) {
        var selector = '.select-country ul.mdc-list';
        var jqCountriesListAddr = this.jqAddressTab_.find(selector);
        VWidgetSearch.fillCountriesByElement(jqCountriesListAddr, countries);
        this.selectAddressCountry_.layoutOptions();
    };
    /**
     * @private
     * @param {JQuery} jqElement JQuery element
     * @param {Array.<Object>} countries Countries
     */
    VWidgetSearch.fillCountriesByElement = function (jqElement, countries) {
        jqElement.empty();
        countries.forEach(function (country) {
            jqElement.append($(createSelectOptionItem({
                label: country[1],
                value: country[0],
            })));
        });
    };
    /**
     * @private
     * @return {string} Autocomplete view
     */
    VWidgetSearch.prototype.getAutocompleteId = function () {
        return this.autocompleteId_;
    };
    /**
     * Reset
     */
    VWidgetSearch.prototype.reset = function () {
        this.currentTab_ = Tabs.ADDRESS;
        this.render_();
    };
    /**
     * @private
     */
    VWidgetSearch.prototype.render_ = function () {
        if (this.currentTab_ === Tabs.ADDRESS) {
            this.jqCoordinatesTab_.hide();
            this.jqAddressTab_.show();
        }
        else if (this.currentTab_ === Tabs.COORDINATES) {
            this.jqAddressTab_.hide();
            this.jqCoordinatesTab_.show();
        }
    };
    return VWidgetSearch;
}(BaseView));
export default VWidgetSearch;
//# sourceMappingURL=VWidgetSearch.js.map